module.exports = __webpack_public_path__ + "static/img/modal_bgzh-tw1.4bfbb3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgzh-tw1.png
// module id = GqhM
// module chunks = 1